import { render, staticRenderFns } from "./MenuEleve.vue?vue&type=template&id=9c2cebdc&scoped=true&"
import script from "./MenuEleve.vue?vue&type=script&lang=js&"
export * from "./MenuEleve.vue?vue&type=script&lang=js&"
import style0 from "./MenuEleve.vue?vue&type=style&index=0&id=9c2cebdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c2cebdc",
  null
  
)

export default component.exports